export * from './login/login.component';
export * from './profile-user/profile-user.component';
